/**
 * Implement Gatsby's Browser APIs in this file.
 * All external libs
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
require("prismjs/themes/prism-tomorrow.css")
